import React, { Component } from "react";
import "./App.css";
import LoginScreen from "./Screens/LoginScreen";
import FinalScreen from "./Screens/FinalScreen";
import StopCodeScreen from "./Screens/StopCodeScreen";
import DialogScreen from "./Screens/DialogScreen";
import LoadingScreen from "./Screens/LoadingScreen";
import AgreementScreen from "./Screens/AgreementScreen";
import AboutApp from "./Screens/AboutApp";
import { INITIAL_STATE, PAGE } from "./constants/general";
import { HEADERS } from "./constants/api";
import { TEXTS } from "./constants/texts";

class App extends Component {
  constructor(props) {
    super(props);

    this.url = `${process.env.REACT_APP_URL_API}/mdemon/mdemon.py`;
    this.urllog = `${process.env.REACT_APP_URL_API}/log.php`;
    this.urlAboutApp = `${process.env.REACT_APP_URL_API}/ademon/intro`;
    // log
    fetch(this.urllog, {
      headers: HEADERS,
      method: "POST",
      body: JSON.stringify({ action: "load" }),
    });

    // vychozi stav aplikace
    this.state = INITIAL_STATE;

    this.handleAnswer = this.handleAnswer.bind(this);
    this.request = this.request.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.sendProtocol = this.sendProtocol.bind(this);
    this.handleAcceptAgreements = this.handleAcceptAgreements.bind(this);
    this.handleAcceptAboutApp = this.handleAcceptAboutApp.bind(this);
    this.requestWelcome = this.requestWelcome.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.increaseAttempt = this.increaseAttempt.bind(this);
    this.handleResetDialog = this.handleResetDialog.bind(this);
  }

  increaseAttempt() {
    this.setState({ number_of_attempts: this.state.number_of_attempts + 1 });
  }

  handleLogin(id, nick, email, tgender, idcontext) {
    // set context
    this.setState({ idcontext: idcontext });

    // login
    let user = this.state.user;

    user["SNICK"] = nick;
    user["SMAIL"] = email;
    if (tgender.trim() !== "") {
      user["TGENDER"] = tgender;
    }

    this.setState({ appid: id, user: user }, function () {
      this.sendProtocol();
    });
  }

  sendProtocol() {
    let protocol = {
      APP: { APPID: this.state.appid, APPCODE: this.state.appcode },
      USER: this.state.user,
      LR: this.state.logrow,
      SC: this.state.stopcode,
    };
    this.request(protocol);
  }

  handleResetDialog() {
    this.increaseAttempt();
    this.setState(
      { logrow: {}, stopcode: 0, appcode: "", screen_counter: 0 },
      function () {
        this.sendProtocol();
      }
    );
  }

  handleAnswer(aid, atp, aco) {
    let lr = {
      AID: aid,
      ATP: atp,
      ACO: aco,
    };
    let that = this;
    this.setState({ logrow: lr }, function () {
      if (this.state.appdata && this.state.appdata.STOPCODE > 0) {
        if (parseInt(that.state.appdata.STOPCODE) === 5) {
          this.setState({ stopcode: 5 }, function () {
            that.sendProtocol();
          });
        } else {
          this.setState({ page: PAGE.STOP_CODE });
        }
      } else {
        that.sendProtocol();
      }
    });
  }

  handleContinue() {
    let screensc = this.state.appdata.STOPCODE;
    this.setState({ stopcode: screensc }, () => {
      this.sendProtocol();
    });
  }

  handleLeave() {
    this.setState({ stopcode: 6 }, () => {
      this.sendProtocol();
    });
  }

  handleEnd() {
    this.setState({
      error: true,
      errorMessage: "Timeout has expired.",
    });
  }

  handleAcceptAgreements() {
    this.setState({ page: PAGE.ABOUT_APP });
  }

  handleAcceptAboutApp() {
    this.sendProtocol();
  }

  componentDidMount() {
    document.documentElement.setAttribute("data-theme", this.state.theme);
  }

  componentDidUpdate(_, prevState) {
    if (prevState.theme !== this.state.theme) {
      document.documentElement.setAttribute("data-theme", this.state.theme);
      localStorage.setItem("theme", this.state.theme);
    }
  }

  toggleTheme = () => {
    this.setState((prevState) => ({
      theme: prevState.theme === "light" ? "dark" : "light",
    }));
  };

  requestWelcome(appid, nick, email, tgender, idcontext) {
    // set context
    this.setState({ idcontext: idcontext });

    let user = this.state.user;
    user["SNICK"] = nick;
    user["SMAIL"] = email;
    if (tgender.trim() !== "") {
      user["TGENDER"] = tgender;
    }
    // Update state and call API
    this.setState({ appid: appid, user: user });

    fetch(`${this.urlAboutApp}/${appid}`)
      .then((res) => res.json())
      .then((result) => {
        const { logo, text01, text02 } = result;

        this.setState(
          {
            logo: logo,
            text01: text01 ?? process.env.REACT_APP_ABOUT_APP,
            text02: text02 ?? process.env.REACT_APP_TERMS,
          },
          () => {
            this.setState({ page: PAGE.ABOUT_APP });
          }
        );
      })
      .catch(() => {
        // Handle error if the API call fails - BE not ready yet
        console.log("No response from the API, using default texts.");
        this.setState(
          {
            logo: "",
            text01: process.env.REACT_APP_ABOUT_APP,
            text02: process.env.REACT_APP_TERMS,
          },
          () => {
            this.setState({ page: PAGE.AGREEMENT });
          }
        );
      });
  }

  request(request) {
    this.setState({ loading: true });
    // console.log(request);

    fetch(this.url, {
      headers: HEADERS,
      method: "POST",
      body: JSON.stringify(request),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log(result);

          if (result.APPCODE || result.STOPCODE) {
            let nextpage = this.nextPageDialogOrStopcode(result);

            this.setState({
              screen_counter: this.state.screen_counter + 1,
              appdata: result,
              appcode: result.APPCODE,
              page: nextpage,
              stopcode: 0,
              logrow: {},
              loading: false,
            });
          } else {
            this.setState({
              error: true,
              errorMessage: "Error",
              loading: false,
            });
          }
        },
        (error) => {
          console.log(error);

          this.setState({
            error: true,
            errorMessage: TEXTS.errors.network,
          });
        }
      );
  }

  renderAcivePage() {
    if (this.state.error) {
      return <FinalScreen message={this.state.errorMessage} />;
    }

    if (this.state.page === PAGE.LOADING) {
      return <LoadingScreen />;
    }
    if (this.state.page === PAGE.AGREEMENT) {
      return (
        <AgreementScreen
          handleAcceptAgreements={this.handleAcceptAgreements}
          text={this.state.text02}
          handleEnd={this.handleEnd}
        />
      );
    }
    if (this.state.page === PAGE.ABOUT_APP) {
      return (
        <AboutApp
          handleAcceptAboutApp={this.handleAcceptAboutApp}
          logo={this.state.logo}
          text={this.state.text01}
          handleEnd={this.handleEnd}
        />
      );
    }
    if (this.state.page === PAGE.LOGIN) {
      return <LoginScreen handleLogin={this.requestWelcome} />;
    }
    if (this.state.page === PAGE.DIALOG) {
      // console.log(this.state.appdata);
      return (
        <DialogScreen
          data={this.state.appdata}
          handleAnswer={this.handleAnswer}
          key={this.state.screen_counter}
          idcontext={this.state.idcontext}
        />
      );
    }
    if (this.state.page === PAGE.STOP_CODE) {
      let sc = this.state.appdata.STOPCODE;
      let msg = this.state.appdata.STOPERR;
      return (
        <StopCodeScreen
          message={msg}
          stopcode={sc}
          btnContinue={this.handleContinue}
          btnLeave={this.handleLeave}
          attempt={this.state.number_of_attempts}
          resetDialog={this.handleResetDialog}
        />
      );
    }
  }

  render() {
    return (
      <>
        <button onClick={this.toggleTheme} className="btn-dark-mode"></button>
        {this.renderAcivePage()}

        <LoadingScreen show={this.state.loading} />
      </>
    );
  }

  nextPageDialogOrStopcode(result) {
    // console.log(
    //   !result.TESTER ||
    //     !result.TESTER.TEMOTIKONID ||
    //     parseInt(result.TESTER.TEMOTIKONID) === 0
    // );
    if (
      (!result.TESTER ||
        !result.TESTER.TEMOTIKONID ||
        parseInt(result.TESTER.TEMOTIKONID) === 0) &&
      (!result.PERSONA ||
        !result.PERSONA.PEMOTIKONID ||
        parseInt(result.PERSONA.PEMOTIKONID) === 0)
    ) {
      return PAGE.STOP_CODE;
    }
    return PAGE.DIALOG;
  }
}

export default App;
